import { render } from "./Footer.vue?vue&type=template&id=5f127340&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=5f127340&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f127340"

export default script